import {Observable, takeUntil} from 'rxjs';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DataStateService, HttpCancelService} from '../service';
import {FORCE_LANGUAGE} from './language-context.token';

@Injectable({providedIn: 'root'})
export class HttpRequestInterceptor implements HttpInterceptor {

	constructor(private translate: TranslateService,
	            private state: DataStateService,
	            private httpCancelService: HttpCancelService) {
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (request.url.includes('assets/i18n')) {
			// request traduzioni! --> inserisco header NO-Cache per ricaricarle sempre
			request = request.clone({
				setHeaders: {'Cache-Control': 'no-cache', Pragma: 'no-cache'}
			});
		} else {

			const forcedLanguage = request.context.get(FORCE_LANGUAGE); // per forzatura della lingua in request (!= da quella corrente)

			const newHeaders: any = {
				'Accept-Language': forcedLanguage || request.headers.get('Accept-Language') || this.translate.currentLang
			};

			if (!!this.state.getUserAzienda) {
				newHeaders['Azienda'] = this.state.getUserAzienda;
			}
			if (this.state.getOpenAppConfig()?.id) {
				newHeaders['Application-Id'] = this.state.getOpenAppConfig().id.toString();
			}
			request = request.clone({setHeaders: newHeaders});
		}
		return next.handle(request).pipe(takeUntil(this.httpCancelService.onCancelPendingRequests()));
	}
}
